import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34536885"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "min-h-screen flex flex-col"
}
const _hoisted_2 = { class: "pt-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_RedirectModal = _resolveComponent("RedirectModal")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createVNode(_component_Spinner),
    _createVNode(_component_Snackbar),
    _createVNode(_component_RedirectModal),
    (_ctx.campaignName !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Header),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in",
                  appear: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}